// extracted by mini-css-extract-plugin
export default {"pole":"WyborSpolki_pole__vmcu6","etykieta":"WyborSpolki_etykieta__E0wGy","lista":"WyborSpolki_lista__tmjxy"};